module.exports = __webpack_public_path__ + "img/icon_60px_3_orange.44efe0d8.svg";